import { FC } from 'react';
import { Col, Grid, Row } from 'antd';
import styles from './Instruction.module.css';
import clsx from 'clsx';
import { TextHeadline } from '../TextHeadline';

export interface InstructionsProps {
	instructions: { iconUrl: string; title: string; description: string }[];
}

export const Instructions: FC<InstructionsProps> = ({ instructions }) => {
	const { md } = Grid.useBreakpoint();
	if (!md) {
		return (
			<Col flex={'auto'}>
				{instructions.map((instruction, index) => (
					<Row align={'stretch'}>
						<Col span={8} flex={'96px'}>
							<Row>
								<img
									className={styles.instructionIcon}
									src={instruction.iconUrl}
									alt={instruction.title}
								/>
							</Row>
							<Row
								justify={'center'}
								align={'middle'}
								className={styles.dottedVerticalLineContainer}
							>
								<div
									className={clsx(
										styles.dottedVerticalLine,
										index === instructions.length - 1 && styles.hideDottedLine,
									)}
								/>
							</Row>
						</Col>
						<Col xs={16} sm={18}>
							<Row>
								<TextHeadline>{instruction.title}</TextHeadline>
							</Row>
							<Row>
								<p>{instruction.description}</p>
							</Row>
						</Col>
					</Row>
				))}
			</Col>
		);
	}
	return (
		<Row align={'stretch'}>
			{instructions.map((instruction, index) => (
				<Col className={styles.container}>
					<Col>
						<Row justify={'space-between'} align={'stretch'}>
							<Col flex={'auto'} className={styles.dottedLineContainer}>
								<div
									className={clsx(
										styles.dottedLine,
										index === 0 && styles.hideDottedLine,
									)}
								/>
							</Col>
							<Col>
								<img
									className={styles.instructionIcon}
									src={instruction.iconUrl}
									alt={instruction.title}
								/>
							</Col>
							<Col flex={'auto'} className={styles.dottedLineContainer}>
								<div
									className={clsx(
										styles.dottedLine,
										index === instructions.length - 1 && styles.hideDottedLine,
									)}
								/>
							</Col>
						</Row>
					</Col>
					<Col className={styles.instructionTitle} flex={'none'}>
						<TextHeadline>{instruction.title}</TextHeadline>
					</Col>
					<Col>
						<p className={styles.description}>{instruction.description}</p>
					</Col>
				</Col>
			))}
		</Row>
	);
};
